import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { HousePlus } from "lucide-react";
import { HomeIcon as HeroHomeIcon, ArrowLeftIcon } from "@heroicons/react/24/solid";

const NotFoundPage: React.FC = () => {
  // Animation variants for the card
  const cardVariants = {
    initial: { opacity: 0, y: 100 },
    animate: { opacity: 1, y: 0, transition: { duration: 0.8, ease: "easeOut" } },
    hover: { rotate: 2, scale: 1.02, transition: { duration: 0.3 } },
  };

  // Animation variants for the icon
  const iconVariants = {
    initial: { scale: 0, rotate: 180 },
    animate: {
      scale: 1,
      rotate: 0,
      transition: { duration: 0.6, delay: 0.2, type: "spring", stiffness: 100 },
    },
  };

  return (
    <div className="flex items-center justify-center min-h-screen px-4 bg-gradient-to-br from-blue-50 to-blue-200 sm:px-6 lg:px-8">
      <motion.div
        variants={cardVariants}
        initial="initial"
        animate="animate"
        whileHover="hover"
        className="w-full max-w-lg p-8 text-center bg-white shadow-2xl rounded-3xl sm:p-12"
      >
        {/* Lucide HousePlus Icon */}
        <motion.div variants={iconVariants} initial="initial" animate="animate" className="mx-auto text-blue-600">
          <HousePlus className="w-24 h-24 sm:w-28 sm:h-28" />
        </motion.div>

        {/* 404 Text */}
        <motion.p
          initial={{ opacity: 0, x: -50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.5, delay: 0.4 }}
          className="text-6xl font-extrabold tracking-widest text-gray-200 sm:text-7xl lg:text-8xl"
        >
          404
        </motion.p>

        {/* Error Message */}
        <motion.p
          initial={{ opacity: 0, x: 50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.5, delay: 0.6 }}
          className="mt-4 text-2xl font-bold tracking-wider text-gray-800 sm:text-3xl"
        >
          Oops ! Page non trouvée
        </motion.p>

        {/* Description */}
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.8 }}
          className="pb-4 mt-4 text-gray-600 border-b-2 border-gray-200"
        >
          La page que vous recherchez semble introuvable.
        </motion.p>

        {/* Back to Home Button */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 1 }}
          className="mt-8"
        >
          <Link
            to="/"
            className="flex items-center justify-center px-6 py-3 space-x-3 text-white transition duration-300 bg-blue-600 rounded-xl hover:bg-blue-700"
          >
            <ArrowLeftIcon className="w-5 h-5" />
            <HeroHomeIcon className="w-5 h-5" />
            <span>Retour à l'accueil</span>
          </Link>
        </motion.div>
      </motion.div>
    </div>
  );
};

export default NotFoundPage;
